import { z } from 'zod';

/** A naming file in the asset library, given to an agent to build from. */
export const importFileSchema = z.object({
  assetId: z.string().min(1),
  fileName: z.string().min(1),
  mimeType: z.string().min(1),
});

export type ImportFile = z.infer<typeof importFileSchema>;

/**
 * What a page opened to build from a file carries in its route state: the file, and for a schema
 * whose rows then become a taxonomy, the campaign that taxonomy goes in.
 */
const importStateSchema = z.object({
  importFile: importFileSchema,
  /** The campaign by name, as the agent files a taxonomy; null for Ungrouped. */
  thenTaxonomy: z.object({ campaignName: z.string().nullable() }).optional(),
});

export type ImportState = z.infer<typeof importStateSchema>;

/** The file a page was opened with, read from route state, which any navigation can set. */
export function importStateOf(state: unknown): ImportState | null {
  const parsed = importStateSchema.safeParse(state);
  return parsed.success ? parsed.data : null;
}
